import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./assets/css/Bootstrap.css";
import "./assets/css/App.css";
import Login from "./auth/Login";
import ForgetPassword from "./auth/ForgetPassword";
import NewPassword from "./auth/NewPassword";
import Dashboard from "./Pages/Dashboard";
import Terms from "./Pages/Terms";
import Privacy from "./Pages/Privacy";
import AboutUs from "./Pages/AboutUs";
import Notification from "./Pages/Notification";
import Users from "./Pages/Users";
import UsersDetail from "./Pages/UserDetails";
import UserPlans from "./Pages/UserPlans";
import UserEvents from "./Pages/UserEvents";
import Explore from "./Pages/Explore";
import AddExplore from "./Pages/AddExplore";
import CityDetails from "./Pages/CityDetails";
import EditExplore from "./Pages/EditExplore";
import Account from "./Pages/Account";
import Link from "./Pages/Links";
import { PlansProvider } from "./context/plansContext";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


function ProtectedRoute({ children }) {
  const authToken = localStorage.getItem("user");
  return authToken ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <BrowserRouter>
      <PlansProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgotpassword" element={<ForgetPassword />} />
          <Route path="/newpassword" element={<NewPassword />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/terms&conditions"
            element={
              <ProtectedRoute>
                <Terms />
              </ProtectedRoute>
            }
          />
          <Route
            path="/privacy"
            element={
              <ProtectedRoute>
                <Privacy />
              </ProtectedRoute>
            }
          />
          <Route
            path="/aboutus"
            element={
              <ProtectedRoute>
                <AboutUs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notification"
            element={
              <ProtectedRoute>
                <Notification />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/detail/:id"
            element={
              <ProtectedRoute>
                <UsersDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/detail/:id/plans/:planId"
            element={
              <ProtectedRoute>
                <UserPlans />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/detail/:id/events/:eventId"
            element={
              <ProtectedRoute>
                <UserEvents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/explore"
            element={
              <ProtectedRoute>
                <Explore />
              </ProtectedRoute>
            }
          />
          <Route
            path="/explore/detail/:id"
            element={
              <ProtectedRoute>
                <CityDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/explore/add"
            element={
              <ProtectedRoute>
                <AddExplore />
              </ProtectedRoute>
            }
          />
          <Route
            path="/explore/detail/edit/:id"
            element={
              <ProtectedRoute>
                <EditExplore />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route
            path="/links"
            element={
              <ProtectedRoute>
                <Link />
              </ProtectedRoute>
            }
          />
          {/* Redirect to dashboard if path doesn't match */}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </PlansProvider>
    </BrowserRouter>
  );
}

export default App;
